const STORAGE_KEY = 'alcor-erp-state-v3';

const loadState = () => {
  if (typeof window === 'undefined') {
    return { purchaseOrders: [], projectBudgets: [] };
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { purchaseOrders: [], projectBudgets: [] };
    const parsed = JSON.parse(raw);
    return {
      purchaseOrders: Array.isArray(parsed?.purchaseOrders) ? parsed.purchaseOrders : [],
      projectBudgets: Array.isArray(parsed?.projectBudgets) ? parsed.projectBudgets : []
    };
  } catch {
    return { purchaseOrders: [], projectBudgets: [] };
  }
};

const CLOSED_ORDER_STATUSES = new Set(['recibida', 'cerrada', 'cancelada', 'rechazada']);

export const getOpenOrders = () => {
  const { purchaseOrders } = loadState();
  return purchaseOrders.filter((order) => !CLOSED_ORDER_STATUSES.has(order.status));
};

export const getSupplierOrders = (supplierId) => {
  const { purchaseOrders } = loadState();
  return purchaseOrders.filter((order) => order.supplierId === supplierId);
};

export const getInvoicedAmount = () => {
  const { purchaseOrders } = loadState();
  return purchaseOrders.reduce((total, order) => total + (order.invoicedValue || 0), 0);
};

export const getProjectInvoicing = (projectId) => {
  const { purchaseOrders, projectBudgets } = loadState();
  const projectBudget = projectBudgets.find((budget) => budget.parkId === projectId);
  if (!projectBudget) return 0;

  return purchaseOrders
    .filter((order) => order.parkId === projectId)
    .reduce((total, order) => total + (order.invoicedValue || 0), 0);
};
